import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// inspections list
import { PeopleListPageComponent } from './pages/list.component';
import { PeopleListComponent } from './components/list.component';

// inspection detail
import { PersonDetailPageComponent } from './pages/detail.component';
import { PersonDetailComponent } from './components/detail.component';

// admin pages (ported from manager)
import { PeopleNewPageComponent } from './pages/new.component';
import { EditPersonDetailPageComponent } from './pages/edit.component';
import { BulkEditPersonDetailPageComponent } from './pages/bulkedit.component';
import { EditPersonJsonPageComponent } from './pages/edit-json.component';

import { routedComponents, PeopleRoutingModule } from './people.routing';
import { TranslateModule } from '@ngx-translate/core';
import { PeopleMenuComponent } from '../menus/plugins/people.menu';
import { UserListMenuComponent } from '../menus/user-list.menu';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, PeopleRoutingModule, TranslateModule, SharedModule],
  declarations: [
    routedComponents,
    PeopleListPageComponent,
    PeopleListComponent,
    PersonDetailPageComponent,
    PersonDetailComponent,
    PeopleMenuComponent,
    PeopleNewPageComponent,
    EditPersonDetailPageComponent,
    BulkEditPersonDetailPageComponent,
    EditPersonJsonPageComponent,
    UserListMenuComponent
  ],
  providers: []
})
export class PeopleModule {}
